import type { EventName } from '@alkor/types';
import { api } from './api';

interface QueuedEvent {
  name: EventName;
  ts: number;
  productId?: string;
  categoryId?: string;
  props?: Record<string, unknown>;
}

const queue: QueuedEvent[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

/**
 * События копятся и уходят пачкой раз в 5 секунд либо при уходе со страницы.
 * Аналитика никогда не влияет на UX: ошибки отправки проглатываются,
 * а падение эндпоинта не должно ронять витрину.
 */
export function track(
  name: EventName,
  payload?: { productId?: string; categoryId?: string; props?: Record<string, unknown> },
): void {
  queue.push({ name, ts: Date.now(), ...payload });
  if (queue.length >= 20) {
    flush();
    return;
  }
  if (!timer) timer = setTimeout(flush, 5000);
}

export function flush(): void {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
  if (queue.length === 0) return;
  const batch = queue.splice(0, queue.length);
  void api.sendEvents(batch);
}

if (typeof document !== 'undefined') {
  // pagehide срабатывает и при сворачивании Telegram, в отличие от unload
  document.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') flush();
  });
}
